export default __webpack_public_path__ + "static/media/sport.3635492f.png";